<template>
  <div v-if="table_permissions" class="custom-content-height h-100">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      fixed-header
      light
      dense
      :height="getvh(56)"
      show-select
      :single-select="disableSelectAllCheckbox"
      :items-per-page="itemPerPage"
      item-key="id"
      class="mx-2 mt-0 font-weight-bold"
      hide-default-footer
      @dblclick:row="showDetail"
      mobile-breakpoint="40"
    >
      <!--    no-data-->
      <template v-slot:no-data> NO DATA HERE!</template>
      <template v-slot:no-results> NO RESULTS HERE!</template>
      <!--    no-data end-->
      <template v-slot:top>
        <div
          class="ma-0 mb-10 pa-0 pt-2 d-flex justify-space-between align-center flex-wrap bg-white position-sticky top-0 zindex-5"
          :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
        >
          <datatable-detail
            :table_properties="table_properties"
            v-if="$vuetify.breakpoint.smAndUp"
          />
          <div
            v-else
            class="d-flex align-center justify-space-between mb-3 w-100"
          >
            <datatable-detail :table_properties="table_properties" />
            <b-button
              v-show="$vuetify.breakpoint.xsOnly"
              depressed
              small
              variant="outline-primary"
              class="px-5 py-3 mb-1 btn--tools"
              @click="toolBarVisionState = !toolBarVisionState"
            >
              TOOLS
            </b-button>
          </div>

          <div
            v-show="isToolbarVisiable"
            class="card-toolbar ma-0 pa-0 col-md-8 col-sm-10 col-12 d-flex flex-wrap align-center justify-content-end"
          >
            <!--begin::Button-->
            <div
              class="mb-1 pa-0 mx-1 mt-1 flex-shrink-0"
              v-if="permissionChecker('create')"
            >
              <b-dropdown
                toggle-class="btn btn--export-filter px-2"
                ref="action-dropdown"
                id="action-dropdown-create"
                class="mb-1 p-0 col-12"
                menu-class="m-0 p-0 ml-n4"
                no-caret
                variant="upload"
              >
                <template v-slot:button-content>
                  <span class="mx-2">Create Return</span>
                  <span class="svg-icon mx-1">
                    <v-icon size="18">mdi-menu-down</v-icon>
                  </span>
                </template>
                <div class="q-status-menu py-1 w-175px">
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="() => toggleCreateReturnModal('iq')"
                    v-if="permissionChecker('create_internal_rvp')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Internal
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="() => toggleCreateReturnModal('external')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      External
                    </div>
                  </div>
                </div>
              </b-dropdown>
            </div>
            <div
              class="mb-1 pa-0 mx-1 flex-shrink-0"
              :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('create')"
            >
              <button
                @click.prevent="assignCarrier"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-cart-plus</v-icon>
                </span>
                Assign Carrier
              </button>

              <ActionDialog
                :refresher="updateTableContent"
                :pageLoader="pageLoad"
                ref="actionDialog"
              />
            </div>
            <div class="mb-1 pa-0 mx-1 mt-1 flex-shrink-0">
              <Print :items="selected" :types="types" />
            </div>
            <div
              class="mb-1 pa-0 mx-1 flex-shrink-0"
              :class="{ 'col-6 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="permissionChecker('export')"
            >
              <button
                @click="$refs.exportSidebar.$data.exportSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-export-variant</v-icon>
                </span>
                Export
              </button>
            </div>
            <!--end::Button-->
            <div
              class="mb-1 pa-0 mx-1 flex-shrink-0"
              :class="{ 'col-6 mt-3': $vuetify.breakpoint.xsOnly }"
              v-if="filters.length > 0"
            >
              <button
                @click="$refs.filterSidebar.$data.filterSidebar = true"
                class="btn btn--export-filter"
              >
                <span class="svg-icon">
                  <v-icon size="18">mdi-filter</v-icon>
                </span>
                Filter
              </button>
            </div>
            <div
              v-if="showBulkActions"
              class="mb-1 pa-0 mx-1 mt-1 flex-shrink-0"
            >
              <b-dropdown
                ref="action-dropdown"
                id="action-dropdown"
                text="Actions"
                class="mb-1 p-0 col-12"
                toggle-class="poppins btn btn--export-filter"
                menu-class="m-0 p-0 ml-n4"
                no-caret
                variant="upload"
              >
                <template v-slot:button-content>
                  <div class="px-2">
                    <span class="svg-icon">
                      <v-icon size="18">mdi-dns</v-icon>
                    </span>
                    <span>Actions</span>
                    <span class="svg-icon mx-2">
                      <v-icon size="18">mdi-chevron-down</v-icon>
                    </span>
                  </div>
                </template>
                <div class="q-status-menu py-1 w-175px">
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkEdit"
                    v-if="permissionChecker('bulk_edit_destination_address')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Edit Address
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="bulkAssignAwb"
                    v-if="permissionChecker('assign_awb')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Assign AWB
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="toggleCreateAsnModal"
                    v-if="permissionChecker('return_order_asn_create')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Create Return ASN
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="createReturnInWMS"
                    v-if="permissionChecker('create_return_in_wms')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Create Return In WMS
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="resetToAssigned"
                    v-if="permissionChecker('order_reset_to_assigned')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Reset to Assigned
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="action3plStatusSync"
                    v-if="permissionChecker('return_3pl_status_sync')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      3pl Status Sync
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="actionResetToConfirm"
                    v-if="permissionChecker('update')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Reset To Confirm
                    </div>
                  </div>
                  <div
                    class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer"
                    @click="resetCarrierRetry"
                    v-if="permissionChecker('reset_error_count')"
                  >
                    <div
                      class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium my-2"
                    >
                      Reset carrier retry
                    </div>
                  </div>
                </div>
              </b-dropdown>
            </div>
            <!--            <div-->
            <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
            <!--              :class="{ 'col-6 mx-8': $vuetify.breakpoint.xsOnly }"-->
            <!--            >-->
            <!--              <Print-->
            <!--                :selectedItems="selected"-->
            <!--                :types="$store.getters.getRETURNSPrintTypes"-->
            <!--                :refresher="updateTableContent"-->
            <!--                :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"-->
            <!--              />-->
            <!--            </div>-->
            <!--            </div>-->

            <!--            <div-->
            <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
            <!--              :class="{ 'col-6 mx-8': $vuetify.breakpoint.xsOnly }"-->
            <!--              v-if="permissionChecker('upload')"-->
            <!--            >-->
            <!--              <button-->
            <!--                class="btn btn&#45;&#45;export-filter"-->
            <!--                @click.prevent="showUploadModal"-->
            <!--                disabled-->
            <!--              >-->
            <!--                <span class="svg-icon">-->
            <!--                  <v-icon size="18">mdi-cloud-upload</v-icon>-->
            <!--                </span>-->
            <!--                Import-->
            <!--              </button>-->
            <!--            </div>-->

            <div
              class="mb-1 pa-0 mx-1 flex-shrink-0"
              v-if="permissionChecker('update_return_status')"
            >
              <button
                class="btn btn--export-filter w-100"
                @click.prevent="() => updateStatus(null, true)"
              >
                <span class="svg-icon d-none d-sm-inline-block">
                  <v-icon size="18">mdi-refresh</v-icon>
                </span>
                Update Status
              </button>
              <ChangeStatus
                :refresher="updateTableContent"
                :pageLoader="pageLoad"
                ref="changeStatus"
                :ids="updateStatusItemId"
                :isMultiple="getIsUpdateStatusItemsMultiple"
              />
            </div>
          </div>
        </div>
        <!-- Export Sidebar start -->
        <ExportSidebar
          ref="exportSidebar"
          :exportHeaders="exportHeaders"
          :downloadItem="downloadItem"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--        end::Export Sidebar-->
        <!-- Filter Sidebar start -->
        <FilterSidebar
          ref="filterSidebar"
          :submitFilterValues="submitFilterValues"
          :resetFilterValues="resetFilterValues"
          :filters="filters"
          :setTableFiltersValues="setTableFiltersValues"
        />
        <!--end::Filter Sidebar-->
        <Others ref="otherData" />
      </template>
      <template
        v-if="!disableSelectAllCheckbox"
        v-slot:header.data-table-select="{ props: { value }, on: { input } }"
      >
        <div
          class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="allSelected"
            @click="selectAll"
          />
        </div>
      </template>
      <template v-slot:item.data-table-select="{ item }">
        <div
          class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="selected"
            @click="selectOne"
            :value="item"
          />
        </div>
      </template>
      <template
        v-for="(head, i) in headers"
        v-slot:[`item.`+head.value]="{ item, header, value }"
      >
        <ComponentSelector
          v-bind:key="i"
          :item="item"
          :header="header"
          :value="value"
          :module="'returns'"
        />
      </template>
      <template #item.action="{ item }">
        <v-menu left transition="scale-transition" offset-y bottom rounded>
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              class="btn btn-light-light btn-hover-info show poppins min-w-100px min-w-md-110px"
            >
              Actions
              <span class="svg-icon svg-icon-5 m-0">
                <v-icon small>mdi-chevron-down</v-icon>
              </span>
            </a>
          </template>
          <v-card class="poppins py-1" elevation="1">
            <div v-if="permissionChecker('update')">
              <v-btn
                :disabled="!item.extra_data.actions.edit"
                class="w-100 text-left"
                @click="() => editItem(item)"
                text
                >Edit
              </v-btn>
            </div>

            <div v-if="permissionChecker('add_exception_comment')">
              <v-btn
                :disabled="!item.extra_data.actions.add_comment"
                class="w-100 text-left"
                @click="() => addComment(item)"
                text
                >Add Comment
              </v-btn>
            </div>

            <div v-if="permissionChecker('duplicate_return')">
              <v-btn
                class="w-100 text-left"
                @click="() => duplicateReturn(item)"
                text
                >Duplicate
              </v-btn>
            </div>
            <div v-if="permissionChecker('update')">
              <v-btn
                class="w-100 text-left"
                :disabled="!item.extra_data.actions.update_boxes"
                :class="
                  !item.extra_data.actions.update_boxes
                    ? 'text-muted'
                    : 'text-dark'
                "
                @click="() => updateOrderClient(item.id)"
                text
                >Update No of box
              </v-btn>
            </div>

            <div v-if="permissionChecker('destroy')">
              <v-btn
                class="w-100 text-left text-danger"
                @click="() => handleDelete(item)"
                text
                >Delete
              </v-btn>
            </div>
          </v-card>
        </v-menu>
      </template>
    </v-data-table>
    <Pagination
      v-if="items.length"
      :setitemPerPage="setItemPerPage"
      :getitemPerPage="getItemPerPage"
      :getpageNumber="getPageNumber"
      :setpageNumber="setPageNumber"
      :totalItems="totalItems"
      :pageCount="pageCount"
      :updateTableContent="updateTableContent"
    ></Pagination>
    <!-- <EditItem
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      ref="editModal"
      :itemForAction="itemForEdit"
    ></EditItem>
      :itemForAction="editItemId"
    ></EditItem> -->

    <QueueUploadModal
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      ref="uploadDoc"
    />
    <AssignCarrier
      ref="assignCarrier"
      :items="selected"
      :updateTableContent="updateTableContent"
    />
    <BulkEditDestination
      ref="bulkEditDestination"
      :items="selected"
      :updateTableContent="updateTableContent"
    />
    <BulkAssignAwb
      ref="bulkAssignAwb"
      :items="selected"
      :updateTableContent="updateTableContent"
    />
    <CreateReturnAsnModal ref="createReturnAsn" :items="selected" />
    <AddComment ref="addComment" :refresher="updateTableContent" />
    <NumberOfBoxModal
      v-if="permissionChecker('update')"
      ref="updateOrderClientModal"
      :refresher="updateTableContent"
    />
  </div>
</template>

<script>
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  SET_TABLE_SORTORDER,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
  SET_CREATE_RETURN_TYPE,
  SET_SERVER_DATA,
  SET_ACTION_TYPE,
} from "@/core/services/store/returned.module";
import {
  SET_PAGE_LOADING,
  SET_REPORT_MODAL_DATA,
  SET_REPORT_MODAL_STATE,
} from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import FilterSidebar from "@/own/components/sidebars/FilterSidebar";
import ExportSidebar from "@/own/components/sidebars/ExportSidebar";

import ActionDialog from "@/own/components/fulfillment/returned/ActionDialog.vue";
import Others from "@/own/components/fulfillment/returned/Others.vue";
// import Print from "@/own/components/fulfillment/returned/Print.vue";
import ChangeStatus from "@/own/components/fulfillment/returned/ChangeStatus.vue";

import ComponentSelector from "@/own/components/datatable/ComponentSelector.vue";
import Pagination from "@/own/components/pagination/Pagination.vue";
import ApiService from "@/core/services/api.service";
import QueueUploadModal from "@/own/components/Modals/QueueUploadModal";
import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";
import getPageWidthHeight from "@/own/mixins/getPageWidthHeight";
import AssignCarrier from "@/own/components/fulfillment/returned/AssignCarrier.vue";
import BulkEditDestination from "@/own/components/fulfillment/returned/BulkEditDestination.vue";
import BulkAssignAwb from "@/own/components/fulfillment/returned/BulkAssignAwb.vue";
import Print from "@/own/components/fulfillment/returned/Print.vue";
import CreateReturnAsnModal from "@/own/components/fulfillment/returned/CreateReturnAsnModal.vue";
import AddComment from "@/own/components/fulfillment/returned/AddComment.vue";
import NumberOfBoxModal from "@/own/components/fulfillment/returned/NumberOfBoxModal.vue";

export default {
  name: "DataTableNew",
  mixins: [getPageWidthHeight],
  components: {
    QueueUploadModal,
    DatatableDetail,
    Pagination,
    FilterSidebar,
    ComponentSelector,
    ExportSidebar,
    AssignCarrier,
    ActionDialog,
    Others,
    ChangeStatus,
    BulkEditDestination,
    BulkAssignAwb,
    Print,
    CreateReturnAsnModal,
    AddComment,
    NumberOfBoxModal,
  },
  props: {
    disableSelectAllCheckbox: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    toolBarVisionState: false,
    selected: [],
    allSelected: false,
    offset: true,

    updateStatusItemId: null,
    isUpdateStatusItemsMultiple: true,
    serverData: null,
  }),
  async beforeMount() {
    await this.$store.dispatch(UPDATE_TABLE_STRUCTURE);
    await this.$store.dispatch(UPDATE_TABLE_DATA);
    this.$store.commit(SET_PAGE_LOADING, false);
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  mounted() {
    this.onResize();

    window.addEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
    types: function () {
      return this.$store.getters.getRETURNSPrintTypes;
    },
    getIsUpdateStatusItemsMultiple() {
      return this.isUpdateStatusItemsMultiple;
    },
    isToolbarVisiable: function () {
      return this.$vuetify.breakpoint.smAndUp ? true : this.toolBarVisionState;
    },
    //pagination
    getItemPerPage: function () {
      return this.$store.getters.getRETURNSTableState.per_page;
    },
    getPageNumber: function () {
      return this.$store.getters.getRETURNSTableState.page;
    },
    totalItems: function () {
      return this.$store.getters.getRETURNSTableData.total;
    },
    pageCount: function () {
      return this.$store.getters.getRETURNSTableData.last_page;
    },
    //filters
    filters: function () {
      return this.$store.getters.getRETURNSTableFilters;
    },

    table_permissions: function () {
      if (this.$store.getters.getRETURNSTablePermissions) {
        return this.$store.getters.getRETURNSTablePermissions.map(function (
          perm
        ) {
          return perm.name;
        });
      } else {
        return false;
      }
    },
    table_properties: function () {
      return this.$store.getters.getRETURNSTableProperties;
    },

    itemPerPage: function () {
      return this.$store.getters.getRETURNSTableState.per_page;
    },
    orderBy: {
      get: function () {
        return this.$store.getters.getRETURNSTableState.sortBy;
      },
      set: function (newValue) {
        if (newValue) {
          this.$store.commit(SET_TABLE_SORTBY, newValue);
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getRETURNSTableState
          );
        } else {
          this.$store.commit(SET_TABLE_SORTBY, "");
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getRETURNSTableState
          );
        }
        this.$store.commit(SET_PAGE_LOADING, false);
      },
    },
    sortOrder: {
      get: function () {
        let sortOrder = true;

        if (this.$store.getters.getRETURNSTableState.sortOrder === "asc") {
          sortOrder = false;
        }
        return sortOrder;
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.commit(SET_TABLE_SORTORDER, "desc");
        } else {
          this.$store.commit(SET_TABLE_SORTORDER, "asc");
        }
        this.$store
          .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getRETURNSTableState)
          .then(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      },
    },
    headers: function () {
      /**
       * @type {[
       {
       value: string,
       text: string,
       type: string,
       sortable: string,
       exportable: string,
       visible: string,
       mobile_visible: string,
       align: string,
       itemClass: string,
       width: string,
       class: string,
       export_order: integer,
       }
       ]}
       */
      let headers = false;
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.$store.getters.getRETURNSTableHeaders) {
          headers = this.$store.getters.getRETURNSTableHeaders.filter(
            (col) => col.visible === true && col.mobile_visible === true
          );
        } else {
          this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {});
          headers = this.$store.getters.getRETURNSTableHeaders.filter(
            (col) => col.visible === true && col.mobile_visible === true
          );
        }
      } else {
        if (this.$store.getters.getRETURNSTableHeaders) {
          headers = this.$store.getters.getRETURNSTableHeaders.filter(
            (col) => col.visible === true
          );
        } else {
          this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {});
          headers = this.$store.getters.getRETURNSTableHeaders.filter(
            (col) => col.visible === true
          );
        }
      }
      headers.forEach((header) => {
        header.class =
          "text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        header.itemClass = "second-text";
        header.width = undefined;
        if (header.value === "aging_day")
          header.class =
            "text-center text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        if (header.value === "action") {
          header.class =
            "pr-10 text-end text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        }
      });
      return headers;
    },
    exportHeaders: function () {
      try {
        return this.$store.getters.getRETURNSTablePermissions
          .find((col) => col.name === "export")
          ?.columns.sort((a, b) => a.order - b.order);
      } catch (error) {
        return null;
      }
    },
    // types: function () {
    //   return [
    //     { name: "Shipping label", value: "label" },
    //     { name: "Barcode", value: "barcode" },
    //     { name: "Invoice", value: "invoice" },
    //     { name: "Manifest", value: "manifest" },
    //     { name: "Packing summary", value: "packing_summary" },
    //     { name: "Packing slip", value: "packing_slip" },
    //   ];
    // },
    items: function () {
      let items = [];
      const serverData = this.$store.getters.getRETURNSTableData;
      if (serverData) {
        items = serverData.data;
      }
      return items;
    },
    editItemIdData() {
      return this.editItemId;
    },
    showBulkActions: function () {
      const bulkActions = [
        "bulk_edit_destination_address",
        "assign_awb",
        "return_order_asn_create",
        "create_return_in_wms",
        "order_reset_to_assigned",
        "return_3pl_status_sync",
        "reset_error_count",
      ];

      if (this.table_permissions.length) {
        return this.table_permissions.some((permission) =>
          bulkActions.includes(permission)
        );
      }
      return false;
    },
  },
  methods: {
    updateOrderClient(id) {
      this.$store.commit(SET_PAGE_LOADING, true);

      this.$nextTick(() => {
        this.$refs.updateOrderClientModal.toggleModal(id);
      });
    },
    addComment(data) {
      this.$nextTick(() => {
        this.$refs.addComment.toggleModal(data);
      });
    },
    createReturnInWMS() {
      if (this.selected.length < 1) {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one record!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/shipping/returns_management/create_return_in_wms", {
        ids: this.selected.map((rec) => rec.id),
      })
        .then((res) => {
          this.$store.commit(SET_REPORT_MODAL_DATA, res.data.messages);
          this.$store.commit(SET_REPORT_MODAL_STATE, true);
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    //
    resetToAssigned() {
      if (this.selected.length < 1) {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one record!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/shipping/returns_management/order_reset_to_assigned", {
        ids: this.selected.map((rec) => rec.id),
      })
        .then(() => {
          // this.$store.commit(SET_REPORT_MODAL_DATA, res.data.messages);
          // this.$store.commit(SET_REPORT_MODAL_STATE, true);
          Swal.fire({
            title: `Success`,
            html: `Reset to assigned successfully`,
            icon: "info",
          });
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    action3plStatusSync() {
      if (this.selected.length < 1) {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one record!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/shipping/returns_management/return_3pl_status_sync", {
        ids: this.selected.map((rec) => rec.id),
      })
        .then(() => {
          // this.$store.commit(SET_REPORT_MODAL_DATA, res.data.messages);
          // this.$store.commit(SET_REPORT_MODAL_STATE, true);
          Swal.fire({
            title: `Success`,
            html: `3pl status sync successfully`,
            icon: "info",
          });
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    actionResetToConfirm() {
      if (this.selected.length < 1) {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one record!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(
        "/shipping/returns_management/order_reset_to_confirm_status",
        {
          ids: this.selected.map((rec) => rec.id),
        }
      )
        .then(() => {
          // this.$store.commit(SET_REPORT_MODAL_DATA, res.data.messages);
          // this.$store.commit(SET_REPORT_MODAL_STATE, true);
          Swal.fire({
            title: `Success`,
            html: `Reset to confirm successfully`,
            icon: "info",
          });
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    resetCarrierRetry() {
      if (this.selected.length < 1) {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one record!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post("/shipping/returns_management/reset_error_count", {
        ids: this.selected.map((rec) => rec.id),
      })
        .then(() => {
          // this.$store.commit(SET_REPORT_MODAL_DATA, res.data.messages);
          // this.$store.commit(SET_REPORT_MODAL_STATE, true);
          Swal.fire({
            title: `Success`,
            html: `Reset confirm retry successfully`,
            icon: "info",
          });
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    updateStatus(item = null, is_multiple = false) {
      if (is_multiple) {
        if (this.selected.length === 0) {
          Swal.fire({
            title: "Warning",
            text: "Please, select at least one order!",
            icon: "warning",
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }
        if (this.selected.length === 1) {
          this.updateStatusItemId = this.selected[0].id;
          this.isUpdateStatusItemsMultiple = false;
        } else {
          this.updateStatusItemId = this.selected;
          this.isUpdateStatusItemsMultiple = true;
        }
      } else {
        this.updateStatusItemId = item.systemId;
        this.isUpdateStatusItemsMultiple = false;
      }
      this.$nextTick(() => {
        this.$refs.changeStatus.toggleModal();
      });
    },
    deleteItem(item) {
      const index = this.selected.findIndex((el) => el.id === item.id);
      index > -1 && this.selected.splice(index, 1);
    },
    deleteAllItems() {
      this.selected.splice(0, this.selected.length);
      this.allSelected = false;
    },
    selectOne(event) {
      this.allSelected && this.deleteItem(event.target.value);

      this.allSelected = false;
    },
    selectAll(event) {
      this.deleteAllItems();
      if (event.target.checked) {
        this.items.forEach((item) => {
          this.selected.push(item);
        });
      }
    },
    onResize() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.toolBarVisionState = false;
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        this.toolBarVisionState = true;
      }
    },
    actionReopen(id) {
      this.pageLoad(true);
      let data = { id: id };
      ApiService.post("/fulfillment/orders/reopen", data)
        .then(() => {
          Swal.fire("Modified!", "Order modified!", "success");
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    // actionCall(item) {
    //   this.$refs.orderCall.$props.item = item;
    //   this.$refs.orderCall.toggleModal();
    // },
    // pagination
    setItemPerPage(val) {
      this.$store.commit(SET_TABLE_PERPAGE, val);
      this.$store.commit(SET_TABLE_PAGE, 1);
      this.deleteAllItems();
    },
    setPageNumber(val) {
      this.$store.commit(SET_TABLE_PAGE, val);
      this.deleteAllItems();
    },
    // pagination end
    // filters
    setTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);
    },
    submitFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);
      let state = { ...this.$store.getters.getRETURNSTableState };
      state.page = 1;
      this.$store
        .dispatch(UPDATE_TABLE_DATA, state)
        .then(() => {
          this.$store.commit(SET_TABLE_PAGE, 1);
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
      this.selected = [];
    },
    resetFilterValues() {
      this.$store.commit(SET_PAGE_LOADING, true);

      this.$store.commit(SET_TABLE_FILTER, []);
      this.$store
        .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getRETURNSTableState)
        .then(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
      this.selected = [];
    },
    // filters end
    /**
     * checks permission and return true/false
     * @types {boolean}
     * example "view","create","update","destroy","show","generate","status","print","activate","upload"
     **/
    permissionChecker(permType) {
      return !!this.table_permissions.includes(permType);
    },
    loadDetailData(id) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = { id: id };
      ApiService.post("/shipping/returns_management/show", data)
        .then((response) => {
          this.$store.commit(SET_PAGE_LOADING, false);
          this.$refs.otherData.setData(response.data.return_management);
          this.$refs.otherData.toggleModal();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoad(true);
          const data = { id: item.id };
          ApiService.post("/shipping/returns_management/destroy", data)
            .then(() => {
              Swal.fire("Deleted!", "Record has been deleted.", "success");
              this.updateTableContent();
            })
            .catch(() => {
              this.pageLoad(false);
            });
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    showDetail(event, { item }) {
      this.loadDetailData(item.id);
    },
    isAnyFilterSelected() {
      let isSelected = false;
      if (this.$store.getters.getRETURNSTableState.filters.length > 0) {
        isSelected = true;
      }
      return isSelected;
    },
    // exports
    downloadItem(columns) {
      if (this.isAnyFilterSelected()) {
        this.$store.commit(SET_PAGE_LOADING, true);
        this.$store
          .dispatch(EXPORT_TABLE_DATA, {
            columns: columns,
            filters: this.$store.getters.getRETURNSTableState.filters,
          })
          .then(() => {
            const link = document.createElement("a");
            link.href = this.$store.getters.getRETURNSExportUrl;
            link.download = "Export.csv";
            link.click();
            setTimeout(() => {
              this.$store.commit(SET_PAGE_LOADING, false);
            }, 1500);
            this.$refs.exportSidebar.$refs.export.toggleModal();
            link.remove();
          });
      } else {
        Swal.fire({
          title: "Warning",
          text: "Please, select at least one filter!",
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },
    // exports end
    handle_function_call(function_name, prop) {
      this[function_name](prop);
    },
    pageLoad(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },

    async updateTableContent() {
      this.pageLoad(true);
      await this.$store
        .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getRETURNSTableState)
        .then(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
      this.$forceUpdate();
      this.selected = [];
      this.pageLoad(false);
    },

    async findNextOrderId(id) {
      // TODO: find and return next order id
      let nextIdIndex = -1;
      let nextId = null;
      this.items.forEach((element, index) => {
        if (element.id.id === id) {
          nextIdIndex = index + 1;
        }
      });
      if (parseInt(this.getItemPerPage) == nextIdIndex) {
        // console.log("last item");
        if (this.pageCount > this.getPageNumber) {
          this.setPageNumber(this.getPageNumber + 1);
          await this.$store
            .dispatch(
              UPDATE_TABLE_DATA,
              this.$store.getters.getPENDINGAUDITORDERSTableState
            )
            .then(() => {
              this.$forceUpdate();
            });
          nextId = this.items[0].id.id;
        }
      } else if (this.items.length - 1 < nextIdIndex) {
        throw TypeError("there is no next order");
      } else {
        try {
          nextId = this.items[nextIdIndex].id.id;
        } catch (e) {
          // console.log(e);
        }
      }
      return nextId;
    },
    async findPrevOrderId(id) {
      // TODO: find and return next order id
      let nextIdIndex = -2;
      let nextId = null;
      this.items.forEach((element, index) => {
        if (element.id.id === id) {
          nextIdIndex = index - 1;
        }
      });
      if (nextIdIndex < 0) {
        if (this.getPageNumber > 1) {
          this.setPageNumber(this.getPageNumber - 1);
          await this.$store
            .dispatch(
              UPDATE_TABLE_DATA,
              this.$store.getters.getPENDINGAUDITORDERSTableState
            )
            .then(() => {
              this.$forceUpdate();
              // console.log("on update", this.items[0].id.id);
            });
          nextId = this.items[parseInt(this.getItemPerPage) - 1].id.id;
        }
      } else {
        try {
          nextId = this.items[nextIdIndex].id.id;
        } catch (e) {
          // console.log(e);
          throw TypeError("Can not find previous order");
        }
      }

      return nextId;
    },
    editItem(id) {
      this.$store.commit(SET_ACTION_TYPE, "edit");
      this.$store.commit(SET_ITEM_FOR_ACTION, id);
      this.editItemId = id;
      this.$nextTick(() => {
        this.$refs.actionDialog.toggleModal(id);
      });
    },
    duplicateReturn(id) {
      this.$store.commit(SET_ACTION_TYPE, "duplicate");
      // this.$store.commit(SET_ITEM_FOR_ACTION, id);
      this.editItemId = id;
      this.$nextTick(() => {
        this.$refs.actionDialog.toggleModal(id);
      });
    },
    toggleCreateReturnModal(type) {
      this.$store.commit(SET_CREATE_RETURN_TYPE, type);
      this.$store.commit(SET_ACTION_TYPE, "create");
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(`/shipping/returns_management/create`)
        .then(({ data }) => {
          this.$store.commit(SET_SERVER_DATA, data);
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .then(() => {
          this.$refs.actionDialog.toggleModal();
        });
    },
    assignCarrier() {
      if (!this.selected.length) {
        Swal.fire({
          title: "No Order Selected",
          text: `Select some orders to assign carrier`,
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.assignCarrier.toggleModal();
    },
    bulkEdit() {
      if (!this.selected.length) {
        Swal.fire({
          title: "No Order Selected",
          text: `Select some orders to assign carrier`,
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.bulkEditDestination.toggleModal();
    },
    bulkAssignAwb() {
      if (!this.selected.length) {
        Swal.fire({
          title: "No Order Selected",
          text: `Select some orders to assign carrier`,
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.bulkAssignAwb.toggleModal();
    },
    toggleCreateAsnModal() {
      if (!this.selected.length) {
        Swal.fire({
          title: "No Order Selected",
          text: `Select some orders to create ASN`,
          icon: "warning",
          showConfirmButton: true,
        });
        return;
      }
      this.$refs.createReturnAsn.toggleModal();
    },
  },
};
</script>
<style>
.q-status-menu {
  max-height: 350px;
  overflow-y: scroll;
}

.drop-item {
  font-weight: 500;
  color: rgb(98, 98, 98);
}

.drop-item:hover {
  font-weight: 600;
  background-color: #eee5ff;
  color: #8950fcff !important;
}
</style>
